import {QueryCacheKeys} from '../../api/cache';
import {getCustomer} from '../../api/customers';
import {getProjects} from '../../api/projects';
import Layout from '../Layout';
import ProjectsTable from '../projects/ProjectsTable';
import {Loader} from '@sproutsocial/racine';
import {useQuery} from '@tanstack/react-query';

interface CustomerInvoiceListProps {
	customerId: string;
}

const CustomerInvoiceList = ({customerId}: CustomerInvoiceListProps) => {
	const {data: customer} = useQuery({
		queryKey: QueryCacheKeys.customer(customerId),
		queryFn: () => getCustomer(customerId),
	});

	const {data: projects} = useQuery({
		queryKey: QueryCacheKeys.customerProjects(customerId),
		queryFn: () => getProjects({customerId}),
	});

	if (!customer || !projects) {
		return <Loader />;
	}

	return (
		<Layout>
			<Layout.Header title={`Projects for ${customer.name}`} />
			<Layout.Body>
				<ProjectsTable projects={projects} showCustomerName={false} />
			</Layout.Body>
		</Layout>
	);
};

export default CustomerInvoiceList;
